import "./animatedunderline.css"
import React from 'react'

function AnimatedUnderline({
  width = 220,
  bottom = -6,
  color = "currentColor",
  strokeWidth = 3,
  delay = "1s",
}) {
  return (
    <svg
      className="animated-underline"
      viewBox="0 0 300 20"
      preserveAspectRatio="none"
      style={{
        width,
        bottom,
        color,
        "--underline-delay": delay,
      }}
    >
      <path
        d="M2,14 Q150,-6 220,4 Q260,9 298"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default AnimatedUnderline;